/**
 * Adaptadores para GET /api/system/comprador-overview → UI /despacho/comprador.
 */
import { formatLicenseDateForDisplay } from "@/lib/licenseDates";
import { ESTADO_COMERCIAL_TONES, MODULO_ESTADO_TONES } from "@/modules/despacho/compradorDespachoMockData";

const BUYER_STATUS_LABELS = {
  active: "Activo",
  trial: "En prueba",
  expired: "Vencido",
  suspended: "Suspendido",
  unknown: "Desconocido",
};

export function mapBuyerStatusLabel(status) {
  return BUYER_STATUS_LABELS[status] || BUYER_STATUS_LABELS.unknown;
}

export function mapBuyerStatusTone(status) {
  const label = mapBuyerStatusLabel(status);
  return ESTADO_COMERCIAL_TONES[label] || "neutral";
}

export function mapModuleEstado(contracted, buyerStatus) {
  if (!contracted) return "No contratado";
  if (buyerStatus === "expired") return "Vencido";
  if (buyerStatus === "suspended") return "Suspendido";
  if (buyerStatus === "trial") return "Activo";
  if (buyerStatus === "active") return "Activo";
  return contracted ? "Activo" : "No contratado";
}

export function mapModulesToTableRows(modules = [], buyerStatus = "unknown") {
  return (modules || []).map((mod) => ({
    id: mod.id,
    label: mod.name,
    contratado: Boolean(mod.contracted),
    estado: mapModuleEstado(Boolean(mod.contracted), buyerStatus),
    fecha_inicio: mod.valid_from ? formatLicenseDateForDisplay(mod.valid_from) : "—",
    fecha_vencimiento: mod.valid_to ? formatLicenseDateForDisplay(mod.valid_to) : "—",
    dias_restantes: mod.days_remaining != null ? String(mod.days_remaining) : "—",
    limite: null,
    _fuenteContratado: mod.source || "entitlements",
  }));
}

export function mapCompradorOverviewToView(overview) {
  if (!overview) return null;
  const buyer = overview.buyer || {};
  const license = overview.license || {};
  const status = buyer.status || "unknown";
  const inTrial = status === "trial";
  const fechaVencimiento = inTrial && license.trial_ends_at
    ? formatLicenseDateForDisplay(license.trial_ends_at)
    : license.valid_to
      ? formatLicenseDateForDisplay(license.valid_to)
      : "—";

  return {
    comprador: {
      nombre_comercial: buyer.workspace_name || buyer.name || "—",
      rfc: buyer.rfc || "—",
      correo_principal: buyer.email || "—",
      usuario_dueno: buyer.email || "—",
      estado_comercial: mapBuyerStatusLabel(status),
      fecha_inicio: license.valid_from ? formatLicenseDateForDisplay(license.valid_from) : "—",
      fecha_vencimiento: fechaVencimiento,
      dias_restantes: license.days_remaining != null ? license.days_remaining : "—",
      plan: inTrial ? "Periodo de prueba" : license.mode || "—",
    },
    modulos: mapModulesToTableRows(overview.modules, status),
    limits: overview.limits || {},
    notes: overview.notes || [],
    estadoTone: mapBuyerStatusTone(status),
    moduloEstadoTones: MODULO_ESTADO_TONES,
    subscriptionMode: license.mode || "—",
    limitsNotConfigured: (overview.limits?.source || "") === "not_configured",
  };
}

export const LIMITS_NOT_CONFIGURED_NOTICE =
  "Algunos límites comerciales aún no están configurados en backend.";

export const PARTIAL_DATA_NOTICE =
  "Vigencia global y módulos contratados provienen del servidor; fechas y límites por módulo pueden seguir sin configurarse.";
